import { Kommune } from '../models/Kommune';

class HelperMethods {
    static distinctArrayByProp(array: any[], prop: any) {
        let unique: any[] = [];
        let distinctItems: any[] = [];

        array.forEach((item: any) => {
            if (unique[item[prop]] === undefined) {
                distinctItems.push(item);
            }

            unique[item[prop]] = 0;
        });

        return distinctItems;
    }
    
    static sortKommuneByNavn(kommuner: Kommune[]) {
        return kommuner.sort((a: any, b: any) => {
            if (a.navn > b.navn) {
                return 1;
            }
            if (a.navn < b.navn) {
                return -1;
            }
            return 0;
        });
    }

    static getSecondsTillDate(date: Date): number {
        const now = new Date();
        const millisecondsTillDate = date.getTime() - now.getTime();
        return Math.abs(millisecondsTillDate / 1000);
    }
}

export default HelperMethods;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/HelperMethods.ts